import React, { useState, Fragment, useCallback, useContext, useEffect } from 'react'
import Dropzone from 'react-dropzone'
import { Flex, Box } from 'reflexbox/styled-components'
import { ThemeContext } from 'styled-components'

import { Close } from 'components/Icons'
import { Text, SemiTitle } from 'components/Typography'

import { Label, DropzoneContainer, ClearButton, ErrorContainer, FileButton, FileLink } from './styles'

const DropzoneInput = ({ label, name, setFieldValue, errors, startFileName = null, fileLink, ...props }) => {
  const theme = useContext(ThemeContext)
  const [currentFile, setCurrentFile] = useState(startFileName)
  const [fileErrors, setFileErrors] = useState(errors)

  const handleDropFile = useCallback(
    file => {
      setFieldValue(name, file[0])
      setCurrentFile(file[0])
    },
    [currentFile],
  )

  useEffect(() => {
    setFileErrors(errors)
  }, [errors])

  return (
    <Fragment>
      {label && <Label>{label}</Label>}
      <DropzoneContainer alignItems='center' justifyContent='center' flexDirection='column' {...props}>
        {currentFile ? (
          <Flex width={1} minHeight={144} alignItems='center' justifyContent='space-around'>
            {startFileName ? (
              startFileName
            ) : (
              <Text variant='small' textAlign='center' color={theme.colors.turquoises.T300} mb={24}>
                {currentFile.name}
              </Text>
            )}
            <ClearButton
              onClick={() => {
                setCurrentFile(null)
                setFieldValue(name, null)
                setFileErrors(null)
              }}
            >
              <Close />
            </ClearButton>
          </Flex>
        ) : (
          <Dropzone onDrop={handleDropFile}>
            {({ getRootProps, getInputProps }) => (
              <div {...getRootProps()}>
                <Flex width={1} flexDirection='column' alignItems='center' justifyContent='center'>
                  <input type='file' {...getInputProps()} accept='.csv' />
                  <Box mb={24}>
                    <Text color={theme.colors.grays.N500}>
                      Para realizar upload da lista de <br /> clientes, utilize o{' '}
                      <FileLink
                        href={fileLink || 'https://guigotv-production-website.s3-us-west-2.amazonaws.com/exemplo.csv'}
                        target='blank'
                        onClick={e => e.stopPropagation()}
                      >
                        arquivo base
                      </FileLink>
                    </Text>
                  </Box>
                  <Box mb={24}>
                    <Text color={theme.colors.grays.N500}>Arraste um arquivo CSV</Text>
                  </Box>
                  <Text textAlign='center' color={theme.colors.grays.N500}>
                    ou
                  </Text>
                  <FileButton mt={24} variant='secondary' type='button'>
                    Selecione um arquivo
                  </FileButton>
                </Flex>
              </div>
            )}
          </Dropzone>
        )}
      </DropzoneContainer>

      {fileErrors && (
        <ErrorContainer mb={24} width={1}>
          <Box mb={16}>
            <SemiTitle color={theme.colors.error}>
              As seguintes linhas do CSV estão inválidas e não puderam ser cadastradas:
            </SemiTitle>
          </Box>
          {fileErrors}
        </ErrorContainer>
      )}
    </Fragment>
  )
}

export default DropzoneInput
